import { render, staticRenderFns } from "./SideTagsRelation.vue?vue&type=template&id=614d2e38&scoped=true&"
import script from "./SideTagsRelation.vue?vue&type=script&lang=js&"
export * from "./SideTagsRelation.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsRelation.vue?vue&type=style&index=0&id=614d2e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614d2e38",
  null
  
)

export default component.exports